export function convertBase64ToBlobUrl(base64String, sliceSize = 512) {
  const contentType = base64String.split(';')[0].split(':').pop();
  const dataString = base64String.split(',').pop();
  const byteCharacters = atob(dataString);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = [];
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers.push(slice.charCodeAt(i));
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return URL.createObjectURL(blob);
}

export function checkIfBase64(stringToCheck) {
  return stringToCheck.split(',')[0].split(';').pop() === 'base64';
}



// WEBPACK FOOTER //
// ./src/helpers/convertToBlob.js